const SuggestedNames = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  return (
  <section className="py-3">
    <div className="container text-center">
      <div className="row">
        <div className="col">
        <img src={`${awsImageBaseUrl}images/clients/GeneralMotors_CadillacEscalade.png`}  className="img-fluid" alt="Hero Background" />
        </div>
      </div>
    </div>
  </section>
 );
};


export default SuggestedNames;